import { useAppSelector } from "../../hooks/StoreHooks";

export const useStatusServiceModule = () =>
  useAppSelector((state) => state.statusServiceModule.module);
